import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL_AUTH = process.env.REACT_APP_API_BASE_URL_AUTH;

export const loginWithOtp = createAsyncThunk(
  "api/fetchData",
  async (userData, { rejectWithValue }) => {
    const formBody = new URLSearchParams();
    formBody.append("username", userData.username);
    formBody.append("otp", userData.otp);
    formBody.append("grant_type", "password");
    try {
      const response = await axios.post(
        `${API_BASE_URL_AUTH}/oauth/token`,
        formBody,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Basic cGh5YmVyLWNsaWVudDpwaHliZXItc2VjcmV0",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      let status = "success";
      let data = {
        status: status,
        message: response.data,
      };
      return data; // Success: return data
    } catch (error) {
      // Handle error: rejectWithValue ensures proper error handling
      let status = "error";
      let data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data;
    }
  }
);

const otpSlice = createSlice({
  name: "api",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginWithOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginWithOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(loginWithOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default otpSlice.reducer;
